/**
 * AddToFolderModalWrapper Loader (dibs-portfolio-folder)
 */
export function loadAddToFolderModalWrapper() {
    return import(
        /* webpackChunkName: "AddToFolderModalWrapper" */
        'dibs-portfolio-folder/src/components/AddToFolderModalWrapper/index.js'
    ).then(exported => exported.default);
}
